/*
  <nc-wordmark>: ajusta el tamaño del texto para que ocupe todo el ancho y, si aparece al hacer scroll,
  sube las letras una a una (el CSS hace la transición; con «reducir movimiento» no se mueve nada).
*/
if (!customElements.get('nc-wordmark')) {
  customElements.define('nc-wordmark', class extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.nc-wordmark__text');
      if (!this.text) return;
      this.fit = this.fit.bind(this);
      // El ajuste va en el frame siguiente: cambiar el tamaño dentro del ResizeObserver avisaría de un bucle.
      this.ro = new ResizeObserver(() => {
        cancelAnimationFrame(this.fr);
        this.fr = requestAnimationFrame(() => this.fit());
      });
      this.fit(true);
      this.ro.observe(this);
      document.fonts?.ready.then(() => requestAnimationFrame(() => this.fit(true)));
      // Solo se anima si todavía no se ve al cargar (si ya está a la vista, se queda quieto).
      if (this.getBoundingClientRect().top > window.innerHeight) {
        this.classList.add('is-armed');
        this.io = new IntersectionObserver(([e]) => {
          if (!e.isIntersecting) return;
          this.classList.add('is-in');
          this.io.disconnect();
        }, { rootMargin: '0px 0px -10% 0px' });
        this.io.observe(this);
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.fr);
      this.ro?.disconnect();
      this.io?.disconnect();
    }

    // Solo recalcula si cambia el ancho (o al cargar la fuente, con force).
    fit(force) {
      const cs = getComputedStyle(this);
      const avail = this.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (avail <= 0 || (!force && avail === this.avail)) return;
      this.avail = avail;
      // El ancho es proporcional al tamaño (el espaciado va en em): regla de tres con el tamaño actual.
      const size = parseFloat(getComputedStyle(this.text).fontSize);
      const w = this.text.getBoundingClientRect().width;
      if (w > 0 && size > 0) this.text.style.fontSize = `${((avail / w) * size).toFixed(2)}px`;
    }
  });
}
